import { Reducer } from "redux";

import { INotificationContainerState } from "./notification";
import { INotificationAction, NotificationActionType } from "./notification.actions";

const initialState: INotificationContainerState = {
    notifications: [],
};

export const notificationReducer: Reducer<INotificationContainerState, INotificationAction> = (
    state = initialState,
    action,
): INotificationContainerState => {
    switch (action.type) {
        case NotificationActionType.PUSH: {
            return { ...state, notifications: [...state.notifications, action.notification] };
        }
        case NotificationActionType.REMOVE: {
            const i = state.notifications.findIndex((n): boolean => n.timeStamp === action.timeStamp);

            if (i === -1) {
                return state;
            }

            return {
                ...state,
                notifications: [
                    ...state.notifications.slice(0, i),
                    ...state.notifications.slice(i + 1),
                ],
            };
        }
        default: {
            return state;
        }
    }
};
